import {PIXI} from '@colonist/pixi'
import {UIGameToolTipView} from './UIGameToolTipView'
import {TranslationObject} from '@colonist/i18n'
import {UIGamePlayerInformationProgressCardView} from '../ui_game_players/UIGamePlayerInformationProgressCardView'
import {UIGamePlayerInformationView} from '../ui_game_players/UIGamePlayerInformationView'
import {CardEnum} from '@colonist/game-states'

export class UIGameProgressCardsToolTipView extends UIGameToolTipView {
    private readonly progressCards: CardEnum[]
    private readonly hideCards: boolean
    private cardH: number

    constructor(viewToPlaceNear: PIXI.Container | PIXI.Sprite, title: TranslationObject, progressCards: CardEnum[], hideCards: boolean, playerInformation?: UIGamePlayerInformationView) {
        super(viewToPlaceNear, title, undefined, progressCards)
        this.progressCards = progressCards
        this.hideCards = hideCards
        this.createDevelopmentCardsView(playerInformation)
    }

    private createDevelopmentCardsView(playerInformation?: UIGamePlayerInformationView) {
        const viewX = 0
        const viewY = this.titleH

        const viewW = this.maxTipWidth
        const viewH = this.cardH

        const textColor = this.textColor

        new UIGamePlayerInformationProgressCardView(this.uiGameManager, viewX, viewY, viewW, viewH, this, this.progressCards, this.hideCards, textColor, playerInformation)
    }

    protected setConstants() {
        this.maxTipWidth = this.itemSize * 2.5
        this.horizontalPadding = this.itemSize * 0.15
        this.cardH = this.itemSize
        this.titleTopPadding = this.itemSize * 0.1
    }

    protected repositionTexts() {
        this.titleTextView.centerXInParent()
    }

    protected setRealWidth() {
        this.tooltipW = this.maxTipWidth
    }

    protected setHeights() {
        this.titleH = this.titleTextView.height + this.titleTopPadding
        this.tooltipH = this.titleH + this.cardH
    }

    removeToolTip() {
        if(this.parent == undefined) return
        this.parent.removeChild(this)
    }
}
